module.exports = __webpack_public_path__ + "img/9791195474271.68a552ff.jpg";